/** Minimal i18n. Selected by the host's data-lang; falls back to English. */

interface Strings {
  live: string;
  ht: string;
  ft: string;
  finished: string;
  noGoals: string;
  title: string;
  ariaRegion: string;
  ariaUpdating: string;
  prev: string;
  next: string;
}

const DICT: Record<string, Strings> = {
  pt: {
    live: "AO VIVO",
    ht: "Intervalo",
    ft: "Terminado",
    finished: "Terminado",
    noGoals: "Sem golos",
    title: "Mundial 2026 · Resultados",
    ariaRegion: "Resultados do Mundial — ao vivo e terminados",
    ariaUpdating: "A atualizar resultados",
    prev: "Anterior",
    next: "Seguinte",
  },
  en: {
    live: "LIVE",
    ht: "Half-time",
    ft: "Full-time",
    finished: "Finished",
    noGoals: "No goals",
    title: "World Cup 2026 · Results",
    ariaRegion: "World Cup results — live and finished",
    ariaUpdating: "Updating results",
    prev: "Previous",
    next: "Next",
  },
  es: {
    live: "EN VIVO",
    ht: "Descanso",
    ft: "Finalizado",
    finished: "Finalizado",
    noGoals: "Sin goles",
    title: "Mundial 2026 · Resultados",
    ariaRegion: "Resultados del Mundial — en vivo y finalizados",
    ariaUpdating: "Actualizando resultados",
    prev: "Anterior",
    next: "Siguiente",
  },
};

export function strings(lang: string): Strings {
  return DICT[lang?.toLowerCase()] || DICT.en;
}

// data-lang -> BCP 47 locale for date formatting.
const LOCALES: Record<string, string> = {
  pt: "pt-BR",
  en: "en-GB",
  es: "es-ES",
};

/**
 * Kickoff label for upcoming matches, in the visitor's own timezone, e.g.
 * "sáb 18:00". Falls back to the raw time on any failure (old browsers, bad
 * input) so a card never renders broken.
 */
export function formatKickoff(iso: string, lang: string): string {
  const locale = LOCALES[lang?.toLowerCase()] || "en-GB";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return new Intl.DateTimeFormat(locale, {
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
  } catch {
    return iso.slice(11, 16);
  }
}
